import { createTheme } from "@mui/material";

export const colorBase = "#a0a0a0";
export const colorBlue = "#0165F4";
export const colorBlueDark = "#011949";
export const colorRed = "#FA5C55";
export const colorGrey = "#73757A";
export const colorLogo = `#4534C2`;
export const colorPurple = colorLogo;
export const colorGreen = `#03BD46`;
export const colorYellow = "#FBC42D";

export const headerStyle = {
  fontWeight: { xs: 750, sm: 750, md: 700 },
  fontSize: { xs: '34px', sm: '34px', md: '50px' },
  lineHeight: { xs: '40px', sm: '40px', md: '52px' },
};

export const GLOBAL_PADDING = {
  p: { xs: '16px', sm: '24px', md: '30px' },
};

export const AI_CHAT_WORKING = false;

export const LINE_TABLE_TOP = {
  verticalTopSX: { fontWeight: 750 },
  verticalBottomSX: { fontWeight: 400 },
  mobileColumn: true,
}

const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1800,
};

const themeData = {
  breakpoints: {
    values: breakpoints,
  },
  palette: {
    primary: {
      main: `${colorBase}`,
      light: `${colorBase}`,
      dark: `${colorBase}`,
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff6333",
      main: "#ff3d00",
      dark: "#b22a00",
      contrastText: "#fff",
    },
    error: {
      light: colorBase,
      main: colorBase,
      dark: colorBase,
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          text: "p",
          title: "h1",
        },
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          color: '#011949',
          textTransform: "none",
          fontFamily: 'inter',
          ...(ownerState.variant === "text" && {
            fontSize: '14px',
            lineHeight: '22px',
          }),
        }),
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({}),
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          padding: 0,
        }),
      },
    },
  },
  typography: {
    useNextVariants: true,
  },
};

export const theme = createTheme(themeData);
